












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class Radiobutton extends Vue {
          @Prop({ default: false, required: false })
          public hasError!: boolean;

          @Prop()
          public label!: string;

          @Prop()
          public value!: boolean;

          public checked = false;

          @Watch('value', { immediate: true })
          public onValueChanged() {
            this.checked = this.value;
  }
}
